import { createFeatureSelector } from '@ngrx/store';

export const wizzardState = createFeatureSelector<OLO.State, OLO.State.Wizzard>('wizzard');
